function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m504.753906 250.316406v58.050782c0 30.707031-24.890625 55.59375-55.597656 55.59375h-173.445312c-9.523438 0-17.175782 7.953124-16.730469 17.570312.445312 9.109375 8.324219 15.914062 17.207031 15.914062h41.019531c9.257813 0 16.75 7.503907 16.75 16.75v41.855469c0 30.90625-25.054687 55.949219-55.945312 55.949219h-48.660157c-30.902343 0-55.957031-25.042969-55.957031-55.949219v-147.457031h-117.796875c-30.707031 0-55.597656-24.890625-55.597656-55.597656v-49.371094c0-30.707031 24.890625-55.597656 55.597656-55.597656h117.796875v-.007813h50.769531c9.503907 0 17.164063-7.921875 16.730469-17.539062-.425781-9.007813-8.179687-15.953125-17.207031-15.953125h-33.542969c-9.246093 0-16.75-7.496094-16.75-16.742188v-41.835937c0-30.90625 25.054688-55.949219 55.957031-55.949219h48.660157c30.839843 0 55.855469 24.949219 55.945312 55.792969v138.925781h115.199219c30.707031 0 55.597656 24.902344 55.597656 55.597656zm0 0",
  fill: "#ffda44"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m504.753906 250.316406v58.050782c0 30.707031-24.890625 55.59375-55.597656 55.59375h-173.445312c-9.523438 0-17.175782 7.953124-16.730469 17.570312.445312 9.109375 8.324219 15.914062 17.207031 15.914062h41.019531c9.257813 0 16.75 7.503907 16.75 16.75v41.855469c0 30.90625-25.054687 55.949219-55.945312 55.949219h-24.332031v-512h24.332031c30.839843 0 55.855469 24.949219 55.945312 55.792969v138.925781h115.199219c30.707031 0 55.597656 24.902344 55.597656 55.597656zm0 0",
  fill: "#ffcd00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m318.261719 437.164062c0 9.246094-7.492188 16.742188-16.738281 16.742188-9.246094 0-16.742188-7.496094-16.742188-16.742188 0-9.246093 7.496094-16.738281 16.742188-16.738281 9.246093 0 16.738281 7.492188 16.738281 16.738281zm0 0",
  fill: "#4895ff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m318.261719 437.164062c0 9.246094-7.492188 16.742188-16.738281 16.742188v-33.480469c9.246093 0 16.738281 7.492188 16.738281 16.738281zm0 0",
  fill: "#2682ff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m333.957031 55.792969v138.925781 22.953125c0 18.503906-14.988281 33.492187-33.492187 33.492187h-110.320313c-9.246093 0-16.75 7.507813-16.75 16.742188v40.6875h-117.796875c-30.707031 0-55.597656-24.898438-55.597656-55.597656v-49.371094c0-30.699219 24.890625-55.597656 55.597656-55.597656h117.796875v-.007813h50.769531c9.503907 0 17.164063-7.921875 16.730469-17.539062-.425781-9.007813-8.179687-15.953125-17.207031-15.953125h-33.542969c-9.246093 0-16.75-7.496094-16.75-16.742188v-41.835937c0-30.90625 25.054688-55.949219 55.957031-55.949219h48.660157c30.839843 0 55.855469 24.949219 55.945312 55.792969zm0 0",
  fill: "#4895ff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m333.957031 55.792969v138.925781 22.953125c0 18.503906-14.988281 33.492187-33.492187 33.492187h-46.785156v-251.164062h24.332031c30.839843 0 55.855469 24.949219 55.945312 55.792969zm0 0",
  fill: "#2682ff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m226.433594 78.695312c0 9.242188-7.496094 16.738282-16.742188 16.738282-9.257812 0-16.75-7.496094-16.75-16.738282 0-9.246093 7.492188-16.753906 16.75-16.753906 9.246094 0 16.742188 7.507813 16.742188 16.753906zm0 0",
  fill: "#ffda44"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m226.433594 78.695312c0 9.242188-7.496094 16.738282-16.742188 16.738282v-33.492188c9.246094 0 16.742188 7.507813 16.742188 16.753906zm0 0",
  fill: "#ffcd00"
});

const SvgPython = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512pt",
  viewBox: "-4 0 512 512",
  width: "512pt",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPython, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/python.8c97ffb9.svg";
export { ForwardRef as ReactComponent };